import React, { FC } from 'react';
import { Image, View } from 'react-native';
import { TWCText } from '@components';
import { useRecoilValue } from 'recoil';

import { TWCTimeLogoIDs } from '@constants';
import { dayDateTimeState } from '@store';

import { styles } from './styles';

import TWCLogoIcon from '../../../assets/icons/twc_logo.png';

/**
 * TWCTimeLogo: A reusable component for displaying the weather channel logo and current system time. Can take in an override
 * for the logo url.
 */

type TWCTimeLogo = {
  logo?: string;
};

export const TWCTimeLogo: FC<TWCTimeLogo> = ({ logo }) => {
  const { time } = useRecoilValue(dayDateTimeState);

  // Get user's time format. Might need to be async in the future
  // This will be useful for providing to useDateTime hook if needed
  // const timeFormat = TimeUtils.getTimeFormat();

  const sourceIcon = logo ? { uri: logo } : TWCLogoIcon;

  return (
    <View style={styles.logoTime}>
      <Image source={sourceIcon} style={styles.logo} testID={TWCTimeLogoIDs.logoAndTimeWidgetLogo} />
      <View style={styles.timeBackground}>
        <TWCText testID={TWCTimeLogoIDs.logoAndTimeWidgetTime} variant={'mediumCondensed'}>
          {time}
        </TWCText>
      </View>
    </View>
  );
};
